(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["srs-custom-toggle-button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('srsCustomToggleButton');
    const panels = document.querySelectorAll('.srs-custom-toggle-panel');

    if (!btn || panels.length === 0) return;

    btn.addEventListener('click', function () {
      const willShow = Array.from(panels).some(function (p) {
        return p.classList.contains('hidden');
      });

      panels.forEach(function (p) {
        if (willShow) {
          p.classList.remove('hidden');
        } else {
          p.classList.add('hidden');
        }
      });

      btn.setAttribute('aria-expanded', willShow.toString());

      if (willShow && panels.length > 0) {
        panels[0].scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
